module.exports = __webpack_public_path__ + "static/media/brand-text.320ee44d.png";